<template>
  <div class="error-page">
    <div class="waves"></div>
    <div class="bubbles">
      <div v-for="n in 10" :key="n" class="bubble" 
        :style="{ '--delay': `${n * 0.5}s`, '--size': `${Math.random() * 30 + 10}px` }">
      </div>
    </div>
    
    <div class="content">
      <div class="lost-fish">
        <div class="fish-body">?</div>
        <div class="fish-tail"></div>
      </div>
      <h1 class="title">{{ $t('error404.title') }}</h1>
      <p class="subtitle">{{ $t('error404.subtitle') }}</p>
      <router-link to="/home" class="return-btn">
        <i class="fas fa-home"></i> {{ $t('error404.returnButton') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404Page'
}
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #1a4572 0%, #062847 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  text-align: center;
  z-index: 2;
  padding: 2rem;
}

.title {
  color: #fff;
  font-size: var(--f-7);
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.subtitle {
  color: #a8d8ff;
  font-size: var(--f-4);
  margin-bottom: 2rem;
}

.return-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 1rem 2rem;
  background: linear-gradient(45deg, #2196f3, #00bcd4);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-size: var(--f-3);
  transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}
@media (hover: hover) {
  .return-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }
}

.lost-fish {
  position: relative;
  width: 120px;
  height: 80px;
  margin: 0 auto 2rem;
  animation: fishFloat 3s ease-in-out infinite;
}

.fish-body {
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--f-7);
  color: #1a4572;
  position: relative;
}

.fish-tail {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 60px;
  background: #fff;
  clip-path: polygon(0 0, 0 100%, 100% 50%);
  animation: tailWag 1s ease-in-out infinite;
}

.waves {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="%230099ff" fill-opacity="0.2" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,234.7C960,235,1056,181,1152,170.7C1248,160,1344,192,1392,208L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>');
  animation: wave 10s linear infinite;
}

.bubbles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.bubble {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: bubbleFloat 8s linear infinite;
  animation-delay: var(--delay);
  width: var(--size);
  height: var(--size);
  left: random(100%);
}

@keyframes fishFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@keyframes tailWag {
  0%, 100% { transform: translateY(-50%) scaleX(1); }
  50% { transform: translateY(-50%) scaleX(-1); }
}

@keyframes wave {
  0% { background-position-x: 0; }
  100% { background-position-x: 1440px; }
}

@keyframes bubbleFloat {
  0% {
    bottom: -100px;
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    bottom: 100vh;
    opacity: 0;
  }
}
</style>
